/** Global constant holding module naming identifier. */
var APP_ID = 'vicApp';

(function() {
    'use strict';

    /** Define all Angular's, local and 3rd party modules. */
    angular.module( APP_ID, [

        // 3rd party
        'ui.router',
        'ngDialog',
        'youtube-embed',
        'ismobile',
        'angulartics',
        'angulartics.google.tagmanager',
        'afkl.lazyImage',
        'oc.lazyLoad',

        // Angular 1.5+ native
        'ngCookies',
        'ngResource',
        'ngSanitize',
        'ngAnimate'
    ]);
})();

// Note: All app-related located in app/core/
